import React from 'react';
import '../../../css/Admin.css';
import TituloPagina from '../../../js/Components/PageTitle';

const Pacientes: React.FC = () => {
      return (
        <div>
        <TituloPagina title="ADMIN - Pacientes | DentalPuente" />

<div className="pbot352">
      
Pacientes Aqui
    </div>
    </div>
    );
}

export default Pacientes;
